var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcConsulting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.915C14.25 3.7975 11.055 1 7.5 1C3.9825 1 0.75 3.7375 0.75 7.96C0.3 8.215 0 8.695 0 9.25V10.75C0 11.575 0.675 12.25 1.5 12.25H2.25V7.675C2.25 4.7725 4.5975 2.425 7.5 2.425C10.4025 2.425 12.75 4.7725 12.75 7.675V13H6.75V14.5H12.75C13.575 14.5 14.25 13.825 14.25 13V12.085C14.6925 11.8525 15 11.395 15 10.855V9.13C15 8.605 14.6925 8.1475 14.25 7.915Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24994 9.25C5.66415 9.25 5.99994 8.91421 5.99994 8.5C5.99994 8.08579 5.66415 7.75 5.24994 7.75C4.83573 7.75 4.49994 8.08579 4.49994 8.5C4.49994 8.91421 4.83573 9.25 5.24994 9.25Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75006 9.25C10.1643 9.25 10.5001 8.91421 10.5001 8.5C10.5001 8.08579 10.1643 7.75 9.75006 7.75C9.33585 7.75 9.00006 8.08579 9.00006 8.5C9.00006 8.91421 9.33585 9.25 9.75006 9.25Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.0225C11.64 4.885 9.78004 3.25 7.53754 3.25C5.26504 3.25 2.82004 5.1325 3.01504 8.0875C4.86754 7.33 6.26254 5.68 6.66004 3.67C7.64254 5.6425 9.66004 7 12 7.0225Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConsulting);
export default __webpack_public_path__ + "static/media/ic-consulting.2d6f32fdcf3a5f00c786f601367d1648.svg";
export { ForwardRef as ReactComponent };